import React from 'react';
import FontIcon from '../FontIcon/FontIcon';
import './DominoTracker.scss';
import DOMINO_STATUS, { IDominoProps, IStatusChecker } from './DominoUtil';
import { getMessage } from 'src/message/utils';

export const DominoTracker = (props: IDominoProps) => {
  const { anomaly, fullOpportunityDetail } = props;
  const dominoStatus = DOMINO_STATUS.map(({label,...rest})=>({...rest,label:getMessage(label)}))
  const getClass = ({
    active,
    completed,
    pending,
    noAction,
    projectWithPrev,
    projectWithoutPrev,
  }: IStatusChecker): string => {
    if (projectWithPrev && projectWithPrev(fullOpportunityDetail)) {
      return '';
    }
    if (projectWithoutPrev && projectWithoutPrev(fullOpportunityDetail)) {
      return '';
    }
    if (completed && completed(anomaly)) {
      return 'completed fa-check';
    }

    if (noAction && noAction(anomaly)) {
      return 'no-action';
    }

    if (active && active(anomaly)) {
      return 'active';
    }
    if (pending && pending(anomaly)) {
      return 'skipped';
    }

    return '';
  };

  const getLineColorClass = (status: any) => {
    if (
      status&&status.projectWithPrevLine &&
      status.projectWithPrevLine(fullOpportunityDetail)
    ) {
      return 'dotted';
    }
    if (
      status&& status.projectWithoutPrevLine &&
      status.projectWithoutPrevLine(fullOpportunityDetail)
    ) {
      return 'dotted';
    }

    if (status.noAction && status.noAction(anomaly)) {
      return 'line-no-action';
    }

    if (status.completed && status.completed(anomaly)) {
      return 'line-completed';
    }

    if (status.rejected && status.rejected(anomaly)) {
      return 'line-rejected';
    }

    if (status.active && status.active(anomaly)) {
      return 'line-active';
    }
    return '';
  };
  return (
    <div>
      <div className='domino' data-testid='domino-test'>
        {dominoStatus.map((status, index) => (
          <FontIcon
            key={index}
            iconName=''
            className={`${status.className} ${getLineColorClass(status)}`}
            iconProps={{ className: getClass({ ...status }) }}>
            {status.label}
          </FontIcon>
        ))}
      </div>
    </div>
  );
};
